import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import styles from './PublicLayout.module.scss';
import { routes } from '../../../config/routes/routes';
import { colors } from '../../styles/colors';
import logo from '../../../assets/logo.png';
import LegalFooter from '../LegalFooter/LegalFooter';

export const PublicLayout = () => {
  return (
    <Box className={styles.publicLayoutContainer}>
      <Box component="header" className={styles.header}>
        <Container maxWidth="lg">
          <Link
            to={routes.homepage}
            className={styles.logoLink}
            style={{ color: colors.buttonContainedPrimaryColor }}
          >
            <img src={logo} alt="Logo" />
          </Link>
        </Container>
      </Box>
      <Box component="main" className={styles.mainContent}>
        <Outlet />
      </Box>
      <LegalFooter />
    </Box>
  );
};

export default PublicLayout;
